module.exports = __webpack_public_path__ + "img/banner.df95f3c4.jpg";